export const GREETINGS = [
  'hello',
  'goodbye',
  'sayonara',
  'hallo',
  'nǐ hǎo',
] as const;
export const PLANETS = ['world', 'mars', 'venus', 'mercury', 'saturn'] as const;
export const pickAtRandom = (strings: string[]): string => {
  return strings[Math.floor(Math.random() * strings.length)];
};
